import React, { useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Paper from '@mui/material/Paper';
import { DataGrid } from '@mui/x-data-grid';

import { LocalizationContext } from '../../../../AppContext';
import Toolbar from './AgreementsTableToolbar';
import ColumnDefinition from './AgreementsTableColumnDefinition';
import RowsMapper from './AgreementsTableRowsMapper';
import localization from './AgreementsTable.local';

export default function AgreementsTable({
  agreementcategories,
  agreements,
  agreementstatuses,
  cities,
  city,
  district,
  districts,
  onRowClick,
  onAddClick,
}) {
  const local = localization[useContext(LocalizationContext)];
  const [rows, setRows] = useState();
  const [columns, setColumns] = useState();
  const [archive, setArchive] = useState(false);

  useEffect(() => setColumns(ColumnDefinition(local, city, district)), [city, district]);
  useEffect(() => setRows(RowsMapper(
    local,
    archive,
    agreementcategories,
    agreements,
    agreementstatuses,
    cities,
    city,
    district,
    districts,
  )), [
    archive,
    agreementcategories,
    agreements,
    agreementstatuses,
    cities,
    city,
    district,
    districts,
  ]);

  return (
    <Paper sx={{ height: '100%' }}>
      { columns && rows && (
        <DataGrid
          sx={{ height: '100%' }}
          rows={rows}
          columns={columns}
          onRowClick={({ row }) => onRowClick(row.id)}
          components={{ Toolbar }}
          componentsProps={{
            toolbar: {
              local, archive, city, onAddClick, onSetArchive: setArchive,
            },
          }}
        />
      )}
    </Paper>
  );
}

AgreementsTable.propTypes = {
  agreementcategories: PropTypes.arrayOf(PropTypes.shape({})),
  agreements: PropTypes.arrayOf(PropTypes.shape({})),
  agreementstatuses: PropTypes.arrayOf(PropTypes.shape({})),
  cities: PropTypes.arrayOf(PropTypes.shape({})),
  city: PropTypes.shape({
    id: PropTypes.number,
  }),
  district: PropTypes.shape({
    id: PropTypes.number,
  }),
  districts: PropTypes.arrayOf(PropTypes.shape({})),
  onRowClick: PropTypes.func.isRequired,
  onAddClick: PropTypes.func.isRequired,
};

AgreementsTable.defaultProps = {
  agreementcategories: undefined,
  agreements: undefined,
  agreementstatuses: undefined,
  cities: undefined,
  city: undefined,
  district: undefined,
  districts: undefined,
};
